<template>
  <drop-down
      v-if="getActiveLanguagesAsArray"
      :initial-active-value="value"
      :labels="languageLabels"
      :open-direction="openDirection"
      :values="getActiveLanguagesAsArray"
      class="language-selector"
      @select="setValue"
  />
</template>

<script>
import {Languages, PlainLanguages} from '@/enum';
import listenerMixinJs from "../mixins/listenerMixin.js";
import DropDown from "./DropDown";

export default {
  name: "LanguageSelector",
  components: {
    DropDown
  },
  mixins: [listenerMixinJs],
  props: {
    value: {type: String, default: null},
    usePlainLanguage: {type: Boolean, default: false},
    /***/
    chooseText: {type: String, default: ""},

    /*
    * Add language keys to exclude
    * **/
    exclude: {
      type: Array, default: () => {
        return []
      }
    },
    /**
     * whether the opened options should expand to the top or to the bottom
     * **/
    openDirection: {type: String, default: "bottom"}
  },
  data() {
    return {
      updateValue: '',
      languages: {},
      closed: true,
      Languages: Languages,
      PlainLanguages: PlainLanguages,
    };
  },
  computed: {
    languageLabels() {
      return this.getActiveLanguagesAsArray.map(item => {
        return this.$t(item);
      });
    },
    getActiveLanguagesAsArray() {
      let languages = this.usePlainLanguage ? PlainLanguages : Languages;
      const langKeys = Object.keys(languages);
      let langs = [];
      for(let i = 0; i < langKeys.length; i++) {
        const key = langKeys[i];
        const obj = languages[key];
        if(obj.active && (!this.exclude || (!this.exclude.includes(obj.name) && !this.exclude.includes(key)))) {
          langs.push(obj.name);
        }
      }

      if(langs.length > 0) {
        const sortedLangs = langs.sort((a, b) => {
          if (a === this.$t('languages.default')) return -1;
          if (b === this.$t('languages.default')) return 1;
          if (a === 'Unknown') return -1;
          if (b === 'Unknown') return 1;
          return a.localeCompare(b);
        });
        return sortedLangs;
      } else {
        return []
      }
    }
  },
  watch: {
    value: function () {
      this.updateValue = this.value;
    },
    updateValue() {
      if (this.updateValue && (this.updateValue !== this.value)) {
        this.$emit('update', this.updateValue);
      } else {
        console.log('not emitting', this.updateValue, this.value)
      }
    },
  },
  beforeMount() {
    this.updateValue = this.value;
  },
  methods: {
    setValue(val) {
      this.updateValue = val;
    },
    toggleOpenClosed() {
      this.closed = !this.closed;
    }
  }
}
</script>

<style lang="scss" scoped>
.invisible {
  visibility: hidden;
  height: 0;
  overflow: hidden;
}

.form-switch {
  border-radius: 3px;
}
</style>